import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer } from '../hooks/useScrollAnimation';
interface TimelineItemProps {
  year: string;
  role: string;
  company: string;
  description: string;
  isLeft: boolean;
}
function TimelineItem({
  year,
  role,
  company,
  description,
  isLeft
}: TimelineItemProps) {
  return <div className={`flex flex-col md:flex-row items-center justify-between w-full mb-12 relative ${isLeft ? 'md:flex-row-reverse' : ''}`} data-id="element-86">
      {/* Content Card */}
      <motion.div variants={fadeInUp} className={`w-full md:w-[45%] bg-dark-card border border-dark-border p-6 rounded-xl relative z-10`} data-id="element-87">
        <div className="font-mono text-gold text-sm mb-1" data-id="element-88">{year}</div>
        <h3 className="text-xl font-bold text-white mb-1" data-id="element-89">{role}</h3>
        <div className="text-gold/70 font-medium mb-3" data-id="element-90">{company}</div>
        <p className="text-slate-400 text-sm leading-relaxed" data-id="element-91">{description}</p>

        {/* Connector Line for Desktop */}
        <div className={`hidden md:block absolute top-1/2 w-8 h-[1px] bg-gold/30 ${isLeft ? '-right-8' : '-left-8'}`} data-id="element-92"></div>
      </motion.div>

      {/* Center Node */}
      <div className="absolute left-0 md:left-1/2 transform md:-translate-x-1/2 w-4 h-4 rounded-full bg-dark-bg border-2 border-gold/60 z-20 mt-[-100%] md:mt-0" data-id="element-93"></div>

      {/* Empty Space for layout balance */}
      <div className="hidden md:block w-[45%]" data-id="element-94"></div>
    </div>;
}
export function CareerTimeline() {
  const roles = [{
    year: '2019 — Present',
    role: 'Chief Technology Officer',
    company: 'Truist Financial (Fortune 100)',
    description: 'Leading enterprise-wide digital transformation across 40+ countries. Managing $1.2B technology budget and 1,700+ engineering organization. Spearheaded migration to hybrid cloud architecture reducing infrastructure costs by $140M annually.'
  }, {
    year: '2015 — 2019',
    role: 'SVP, Infrastructure & Cloud',
    company: 'Wells Fargo',
    description: 'Architected cloud-first strategy and rebuilt legacy trading platforms to microservices architecture, improving throughput by 400%. Led zero-trust security implementation across 250,000+ endpoints.'
  }, {
    year: '2011 — 2015',
    role: 'VP, Technology Infrastructure',
    company: 'USAA',
    description: 'Built and scaled platform serving 13M+ members. Achieved SOC 2 Type II, PCI DSS Level 1, and HITRUST certification while scaling engineering team from 20 to 150 engineers.'
  }, {
    year: '2007 — 2011',
    role: 'Director of Enterprise Architecture',
    company: 'AIG',
    description: 'Led infrastructure modernization programs across global insurance operations. Implemented enterprise security protocols and regulatory compliance frameworks for 50+ jurisdictions.'
  }, {
    year: '2003 — 2007',
    role: 'Senior Infrastructure Architect',
    company: 'General Motors',
    description: 'Designed carrier-grade manufacturing systems for 99.999% uptime. Delivered global ERP infrastructure supporting $180B in annual operations across 35 countries.'
  }, {
    year: '1999 — 2003',
    role: 'Systems Architect',
    company: 'Hewlett-Packard',
    description: 'Designed and deployed enterprise server infrastructure for Fortune 500 clients. Specialized in high-availability architectures and disaster recovery planning.'
  }];
  return <section id="career-timeline" className="py-20 md:py-32 bg-dark-bg relative" data-id="element-95">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-96">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={staggerContainer} data-id="element-97">
          <motion.div variants={fadeInUp} className="mb-16 text-center" data-id="element-98">
            <span className="font-sans text-gold/80 tracking-widest uppercase text-xs font-semibold mb-2 block" data-id="element-99">
              Career Trajectory
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white" data-id="element-100">
              Professional History
            </h2>
          </motion.div>

          <div className="relative" data-id="element-101">
            {/* Center Line */}
            <div className="absolute left-2 md:left-1/2 top-0 bottom-0 w-[2px] bg-gradient-to-b from-gold/10 via-gold/30 to-gold/10 transform md:-translate-x-1/2" data-id="element-102"></div>

            <div className="pl-8 md:pl-0" data-id="element-103">
              {roles.map((role, index) => <TimelineItem key={index} {...role} isLeft={index % 2 !== 0} data-id="element-104" />)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}